import React, { useRef } from 'react';
import emailjs from 'emailjs-com';


const Contacto = () => {
    const form = useRef();

  const enviarCorreo = (e) => {
    e.preventDefault();

    emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', form.current, 'YOUR_USER_ID')
      .then(() => {
        alert('Mensaje enviado con éxito');
        form.current.reset();
      })
      .catch((error) => {
        console.error(error);
        alert('Ocurrió un error al enviar el mensaje');
      });
  };

  
    return (
        <section className="py-20 px-4 bg-white text-center">
            <h2 className="text-3xl md:text-4xl font-serif text-primary mb-10">Contáctanos</h2>

            <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-10 text-left">
                {/* Formulario */}
                <div>
                    <form className="space-y-4">
                        <div>
                            <label className="block text-gray-700 mb-1">Nombre</label>
                            <input type="text" className="w-full border border-gray-300 p-3 rounded-md" placeholder="Tu nombre" />
                        </div>
                        <div>
                            <label className="block text-gray-700 mb-1">Correo electrónico</label>
                            <input type="email" className="w-full border border-gray-300 p-3 rounded-md" placeholder="tu@email.com" />
                        </div>
                        <div>
                            <label className="block text-gray-700 mb-1">Mensaje</label>
                            <textarea className="w-full border border-gray-300 p-3 rounded-md h-32" placeholder="¿En qué podemos ayudarte?"></textarea>
                        </div>
                        <button
                            type="submit"
                            className="bg-primary text-white px-6 py-3 rounded-full hover:bg-pink-700 transition"
                        >
                            Enviar mensaje
                        </button>
                    </form>
                </div>

                {/* Información de contacto */}
                <div className="text-gray-700 space-y-4">
                    <p><strong>Dirección:</strong> Unicentro Virginia Piso 1 Local 1-01, Maracaibo</p>
                    <p><strong>Teléfono:</strong> +58 424-6440230</p>
                    <p><strong>Email:</strong> info@clinicacorium.com</p>

                    {/* Mapa */}
                    <div className="mt-6">
                        <iframe
                            title="Ubicación Clínica Corium"
                            className="w-full h-64 rounded-md border"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31353.22461515579!2d-71.65646589999999!3d10.6513226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e899bff7037e209%3A0xf84e74fcf987b06d!2sC.%2072%20Gilberto%20Correa%2C%20Maracaibo%204002%2C%20Zulia%2C%20Venezuela!5e0!3m2!1ses-419!2sve!4v1716517232292!5m2!1ses-419!2sve"
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contacto;
